import { useFormContext, useWatch } from 'react-hook-form'

import { Form } from '@/shared/ui'

type Props = {
  label: string
}

export const PhoneField = ({ label }: Props) => {
  const { control } = useFormContext()

  const phoneNumber = useWatch({
    control,
    name: 'phoneNumber',
  })

  return (
    <Form.Field name="phoneNumber" readOnly>
      <Form.Label className="font-medium text-black">{label}</Form.Label>
      {phoneNumber && <Form.TextField type="tel" readOnly fullWidth />}
    </Form.Field>
  )
}
